/**
 * Menu script
 */
class MWF_Menu {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.site-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menu = this.menuWrapper.find('.menu');
    }

    initEvents() {
        $(window).on('scroll', () => {
            let positionY = this.win.scrollTop();

            if (positionY > 48 && !this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.addClass('is-fixed');
                return;
            }

            if (positionY <= 48 && this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.removeClass('is-fixed');
            }
        });

        $(window).trigger('scroll');

        if (this.menuIcon.length) {
            this.menuIcon.on('click', e => {
                e.preventDefault();
                
                if (this.menuIcon.attr('aria-expanded') === 'false') {
                    this.menuIcon.attr('aria-expanded', 'true');
                } else if (this.menuIcon.attr('aria-expanded') === 'true') {
                    this.menuIcon.attr('aria-expanded', 'false');
                }
            });
        }
    }
}
